import { ApiResponse, HTTPVerb } from '../Modules/Utils/API/Interfaces/IApi';
import { ApiManager } from '../Modules/Utils/API/ApiManager';

enum APIConstants {
    GetRealityCheck = '/api/Settings/GetRealityCheck/',
}

export default class SettingsApi {
    public static GetRealityCheck = async (): Promise<ApiResponse<boolean>> => {
        return ApiManager.getAPIInstance().authenticatedRequest({
            url: APIConstants.GetRealityCheck,
            method: HTTPVerb.GET,
        });
    };
}
